import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';
import { QueryOptions } from 'src/libs/react-query';
import { leaderboardKeys } from './leaderboard-keys';

export interface Participant {
  rank: number;
  user_id: string;
  wallet_address: string;
  account_equity: number;
  volume: number;
  pnl: number;
  roi: number;
  points: number;
  tier: string;
}

interface UserStats {
  account_equity: number;
  pnl: number;
  points: number;
  rank: number;
  roi: number;
  tier: string;
  user_id: string;
  volume: number;
  wallet_address: string;
}

export interface CurrentXPLeaderboardResponse {
  start_date: string;
  end_date: string;
  participants: Participant[];
  total: number;
  page_size: number;
  page_number: number;
  user?: UserStats;
}
export interface GetXPLeaderboardParams {
  page: number;
  page_size: number;
  useraddress?: string;
  start_date?: string;
  end_date?: string;
}
export const getXPLeaderboard = async (params: GetXPLeaderboardParams) => {
  const response = await apiClient.get<CurrentXPLeaderboardResponse>(
    '/v1/public/user-leaderboard/current-week',
    {
      params,
    },
  );

  return response.data;
};

export type UseGetXPLeaderboardOptions<TData, TError> = QueryOptions<
  CurrentXPLeaderboardResponse,
  TError,
  CurrentXPLeaderboardResponse,
  ReturnType<typeof leaderboardKeys.getXPLeaderboardParams>
>;

export const useGetXPLeaderboard = <TData = CurrentXPLeaderboardResponse, TError = Error>(
  params: GetXPLeaderboardParams,
  options?: UseGetXPLeaderboardOptions<TData, TError>,
) => {
  return useQuery({
    queryKey: leaderboardKeys.getXPLeaderboardParams(params),
    queryFn: () => getXPLeaderboard(params),
    enabled: true,
    ...options,
  });
};
